import { ArrowBack } from '@mui/icons-material';
import { Stack } from '@mui/material';

export function BackButton({
  onClick,
  text,
}: {
  onClick: () => void;
  text: string;
}) {
  return (
    <Stack
      display={'flex'}
      flexDirection={'row'}
      alignItems={'center'}
      sx={{ cursor: 'pointer' }}
      onClick={onClick}
      width={'fit-content'}
    >
      <ArrowBack sx={{ mr: 1 }} />
      {text}
    </Stack>
  );
}
